import React, { useEffect, useState } from "react";
import TrashIcon from "assets/icon/TrashIcon";
import { useNavigate } from "react-router-dom";
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, DropdownStatusList, EmptyString, FormTypeAdd, FormTypeEdit, FormTypeView, MenuProjectId, PageSize, PaginationBack, PaginationFirst, PaginationLast, PaginationNext } from "utils/Constant";
import { ApiGetProjectList, ApiDeleteProject, ApiCheckUserMenuAccess } from "utils/constants/api";
import useFetch from "utils/hooks/useFetch";
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import EditIcon from "assets/icon/EditIcon";
import PaginationButton from "components/Input/PaginationButton";
import SearchButton from "components/Button/SearchButton";
import Dropdown from "components/Input/Dropdown";
import AddButton from "components/Button/AddButton";
import { GetStatus } from "utils/helpers";
import RevisionIcon from "assets/icon/RevisionIcon";
import ShowIcon from "assets/icon/ShowIcon";

export default function Project(){
    let navigate = useNavigate()
    
    const { data: projectList, fetch: getProjectList } = useFetch(ApiGetProjectList)
    const { fetch: deleteProject } = useFetch(ApiDeleteProject)
    const { fetch: checkAccess } = useFetch(ApiCheckUserMenuAccess)

    const [clientName, setClientName] = useState(EmptyString)
    const [marketingName, setMarketingName] = useState(EmptyString)
    const [projectLocation, setProjectLocation] = useState(EmptyString)    
    const [status, setStatus] = useState(DropdownStatusList[1].value)

    const [allowCreate, setAllowCreate] = useState(false)
    const [allowEdit, setAllowEdit] = useState(false)
    const [allowDelete, setAllowDelete] = useState(false)
    const [allowUndelete, setAllowUndelete] = useState(false)
    const [allowView, setAllowView] = useState(false)

    const clientNameChange = (e) => {
        setClientName(e.target.value)
    }
    const marketingNameChange = (e) => {
        setMarketingName(e.target.value)
    }
    const projectLocationChange = (e) => {
        setProjectLocation(e.target.value)
    }
    const statusChange = (e) => {
        setStatus(e.value)
    }

    // Grid
    const[paginationOptions, setPaginationOptions] = useState([])
    const[pageIndex, setPageIndex] = useState("")
    const[totalPageCount, setTotalPageCount] = useState(0)

    // Modal
    const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
	const [loading, setLoading] = useState({isOpen: false})
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, data: {} })

    const addBtnClick = () => {
        navigate("/company/project/form?projectId=&formType=" + FormTypeAdd)
    }
    const editBtnClick = (projectId) => {
        navigate("/company/project/form?projectId=" + projectId + "&formType=" + FormTypeEdit)
    }
    const viewBtnClick = (projectId) => {
        navigate("/company/project/view?projectId=" + projectId + "&formType=" + FormTypeView)
    }
    const deleteBtnClick = (projectId, status) => {
        setConfirmationModal({
            isOpen: true,
            data: {
                onSuccess: async () => {
                    setConfirmationModal({ isOpen: false })
                    setLoading({isOpen: true})

                    let stat = 1

                    if (status === 1){
                        stat = 2
                    }else if (status === 2){
                        stat = 1
                    }

                    fDeleteProject(projectId, stat).then(() => {
                        fBindGrid(pageIndex)
                    })
                }
            }
        })
    }
    const searchBtnClick = () => {
        fBindGrid(0)
    }
    const enterKeyPress = (e) => {
        if(e.key === 'Enter'){
			fBindGrid(0)
		}
    }

    useEffect(() => {
        setLoading({isOpen: true})

        fCheckUserAccess(localStorage.getItem("Id"), MenuProjectId, localStorage.getItem("CompanyId")).then((res) => {
            if(!res.access){
                navigate("/access-denied")
            }
            if(res.create){
                setAllowCreate(true)
            }
            if(res.edit){
                setAllowEdit(true)
            }
            if(res.delete){
                setAllowDelete(true)
            }
            if(res.unDelete){
                setAllowUndelete(true)
            }
            if(res.view){
                setAllowView(true)
            }
            fBindGrid(0)
        })        
    },[])

    // Function Api Call
    async function fGetProjectList(index){
        let res

        await getProjectList({
            data: {
                companyId: localStorage.getItem("CompanyId"),
                status: status,
                clientName: clientName,
                projectLocation: projectLocation,
                pageSize: PageSize,
                pageIndex: parseInt(index)
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                res = response
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })

        return res
    }
    async function fDeleteProject(paramProjectId, paramStatus){
        await deleteProject({
            data: {
                projectId: paramProjectId,
                status: paramStatus
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                setSuccessModal({ 
                    isOpen: true, 
                    data: {
                        onSuccess: async () => {
                            setSuccessModal({ isOpen: false })
                        }
                    }
                })
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({ isOpen: false })
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({ isOpen: false })
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fCheckUserAccess(userId, menuId, companyId){     
        let access
     
        await checkAccess({
           data: {
              userId: userId, 
              menuId: menuId,
              companyId: companyId
           }
        }).then((response) => {
           if(response.status === ApiResponseSuccess){
              access = response.data
           }else if(response.status === ApiResponseStatusUnauthorized){
              window.location.href = "/login"
           }
        })
     
        return access
    }

    // Function Grid
    async function fBindGrid(index){
        setLoading({isOpen: true})

        let i = index !== null ? (index !== EmptyString ? parseInt(index) : 0) : 0

        fGetProjectList(i).then((res) => {
            if (res !== null){
                let totalData = res.data.totalData
                fSetPaginationOptions(totalData, index)
            }
            setLoading({isOpen: false})
        })
    }
    function fSetPaginationOptions(dataCount, index){
        let numberOfPage = Math.ceil(parseInt(dataCount)/PageSize)
        let array = []
        
        setTotalPageCount(numberOfPage = 0 ? 1 : numberOfPage)

        for (let i = 0; i < numberOfPage; i++){
            array.push({
                label: String(i + 1),
                value: String(i)
            })
        }
        
        setPaginationOptions(array)
        
        if(index !== "" && index !== null){
            setPageIndex(String(index))
        }else{
            setPageIndex("0")
        }
    }
    function fPaginationBtnClick(command){
        if(command === PaginationFirst){
            setPageIndex("0")
            fBindGrid(0)
        }else if(command === PaginationBack){
            let index = parseInt(pageIndex) - 1

            if(index >= 0){
                setPageIndex(index)
                fBindGrid(index)
            }
        }else if(command === PaginationNext){
            let index = parseInt(pageIndex) + 1

            if (totalPageCount >= index){
                setPageIndex(index)
                fBindGrid(index)
            }
        }else if(command === PaginationLast){
            let index = totalPageCount

            setPageIndex(index)
            fBindGrid(index)
        }
    }
    function fPaginationIndexChange(index){
        setPageIndex(index)
        fBindGrid(index)
    }

    return(
        <div className="flex flex-col gap-2">
            <div >
                <span className="font-semibold text-2xl">Project</span>
            </div>
            <hr />

            <div className="flex flex-col sm:flex-row justify-between gap-4 mt-5">
                <div className="flex flex-col sm:flex-row gap-2 sm:gap-4">
                    <div className="flex flex-col gap-2 w-full sm:w-3/12 2xl:w-72">
                        <span>Client</span>
                        <input className="input" value={clientName} onChange={clientNameChange} onKeyDown={enterKeyPress} />
                    </div>
                    <div className="flex flex-col gap-2 w-full sm:w-3/12 2xl:w-72">
                        <span>Marketing</span>
                        <input className="input" value={marketingName} onChange={marketingNameChange} onKeyDown={enterKeyPress} />
                    </div>
                    <div className="flex flex-col gap-2 w-full sm:w-3/12 2xl:w-72">
                        <span>Project Location</span>
                        <input className="input" value={projectLocation} onChange={projectLocationChange} onKeyDown={enterKeyPress} />
                    </div>
                    <div className="flex flex-col gap-2 w-full sm:w-3/12 md:w-36 2xl:w-72">
                        <span>Status</span>
                        <Dropdown value={status} options={DropdownStatusList} onChange={statusChange} placeholder={"All"} />
                    </div>
                </div>
                <div>
                    <div className="flex items-end justify-end h-full">
                        <SearchButton onClick={searchBtnClick} />
                    </div>
                </div>
            </div>

            <div className={`flex w-full justify-end ${allowCreate ? 'flex' : 'hidden'}`}>
                <AddButton onClick={addBtnClick} />
            </div>
           
            <div className="mt-5">
                <table className="w-full border bg-white">
                    <thead>
                        <tr className="h-12">
                            <th className="font-semibold w-16">No</th>
                            <th className="font-semibold text-left px-2">Client</th>
                            <th className="font-semibold text-left px-2 hidden sm:table-cell">Marketing</th>
                            <th className="font-semibold text-left px-2 hidden md:table-cell">Project Location</th>
                            <th className="font-semibold text-left px-2 hidden md:table-cell">Status</th>
                            <th className="font-semibold w-24">Action</th>
                        </tr>
                    </thead>
                    <tbody className="border">
                        {projectList?.data?.listData?.map((data, i) => {
                            return(
                                <tr className="my-2 row h-10 border-y" key={ i }>
                                    <td className="text-center">{ data.rowNumber }</td>
                                    <td className="px-2">
                                        <span>{ data.clientName }</span>
                                    </td>
                                    <td className="px-2 hidden sm:table-cell">
                                        <span>{ data.marketingName }</span>
                                    </td>
                                    <td className="px-2 hidden md:table-cell">
                                        <span>{ data.projectLocation }</span>
                                    </td>
                                    <td className="px-2 hidden md:table-cell">
                                        <span>{ GetStatus(data.status) }</span>
                                    </td>
                                    <td className="flex justify-center py-2 gap-2 px-2">
                                        <button className={`button flex gap-2 ${allowView ? 'flex' : 'hidden'}`} onClick={() => viewBtnClick(data.projectId)}>
                                            <ShowIcon className="w-4 fill-white" />
                                        </button>
                                        <button className={`button flex gap-2 ${allowEdit ? 'flex' : 'hidden'}`} onClick={() => editBtnClick(data.projectId)}>
                                            <EditIcon className="w-4 fill-white" />
                                        </button>
                                        <button className={`button flex gap-2 ${ data.status === 1 ? (allowDelete ? 'flex' : 'hidden') : 'hidden' }`} onClick={() => deleteBtnClick(data.projectId, data.status)}>
                                            <TrashIcon className="w-4 fill-white" />
                                        </button>
                                        <button className={`button flex gap-2 ${ data.status === 1 ? 'hidden' : (allowUndelete ? 'flex' : 'hidden') }`} onClick={() => deleteBtnClick(data.projectId, data.status)}>
                                            <RevisionIcon className="w-4 fill-white" />
                                        </button>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>

            <PaginationButton btnFirstClick={() => { fPaginationBtnClick(PaginationFirst) }} btnBackClick={() => { fPaginationBtnClick(PaginationBack) }} 
                options={paginationOptions} value={pageIndex} onChange={(e) => { fPaginationIndexChange(e.value) }} btnNextClick={() => { fPaginationBtnClick(PaginationNext) }}
                btnLastClick={() => { fPaginationBtnClick(PaginationLast) }}
            />

            {/* Modal */}
			{failModal.isOpen && ( <FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} /> )}
			{loading.isOpen && (<LoadingModal onClose={() => setLoading({ isOpen: false })} />)}
            {successModal.isOpen && ( <SuccessModal onClose={() => setSuccessModal({ isOpen: false, data: {} })} data={successModal?.data} /> )}
            {confirmationModal.isOpen && ( <ConfirmationModal onClose={() => setConfirmationModal({ isOpen: false, data: {} })} data={confirmationModal?.data} /> )}
        </div>
    )
}